export enum QuantityKgStatus {
  BelowLimit = "Ниже лимита",
  AboveLimit = "Выше лимита",
  WithinLimit = "В лимите",
}

export interface Report {
  _id: string;
  date: string;
  warehouseMgrId: string;
  warehouseMgrName: string;
  details: Array<{
    quantity: number;
    quantityKg: number;
    residueBefore: number;
    residueAfter: number;
    produceId?: string;
    produceName?: string;
    wasteProduced: number;
    quantityKgStatus?: QuantityKgStatus;
  }>;
  snapshot: string;
}
